// extracted by mini-css-extract-plugin
export default {"cardTitle":"entity-skill-scores-card_cardTitle__w-0bd","cardContent":"entity-skill-scores-card_cardContent__JbvwL","skillScore":"entity-skill-scores-card_skillScore__lfMyK"};